import axios from "axios";


class EmployeeService { 

    getEmployees(){ 
        return axios.get("https://railwayd-production.up.railway.app/employee/getall");
    }

    addEmployee(student) { 
        return axios.post("https://railwayd-production.up.railway.app/employee/create",student);
    }
    updateEmployee(student) { 
        return axios.put("https://railwayd-production.up.railway.app/employee/update",student);
    }
    deleteEmployee(id) { 

        return axios.delete(`https://railwayd-production.up.railway.app/employee/delete?id=${id}`)

    }
    viewEmployee(id) { 

        return axios.get(`https://railwayd-production.up.railway.app/employee/getbyid?id=${id}`)

    }
    searchEmployee(query) { 

        return axios.get(`https://railwayd-production.up.railway.app/employee/search?query=${query}`)

    }
    
}

export default new EmployeeService();